<template>
  <div>
    <div class="mains" v-if="loading" v-loading="loading" element-loading-spinner="el-icon-loading"></div>
    <div v-else>
      <div class="man-title">
        <span>检修任务</span>
      </div>
      <div class="table-list">
        <el-table :data="tableData" style="width: 100%">
          <el-table-column label="序号" type="index" width="50"></el-table-column>
          <el-table-column prop="order" label="检修代号"></el-table-column>
          <el-table-column prop="alias" label="设备别名"></el-table-column>
          <el-table-column prop="deviceName" label="设备名称"></el-table-column>
          <el-table-column prop="specification" label="设备参数"></el-table-column>
          <el-table-column prop="deviceTypeName" label="设备类型"></el-table-column>
          <el-table-column prop="patrolName" label="巡视点名称"></el-table-column>
          <el-table-column prop="facilityName" label="设施位置"></el-table-column>
          <el-table-column label="来源">
            <template slot-scope="scope">
              {{ scope.row.source==0 ? '新建' : scope.row.source==1 ? '巡检' : '点检' }}
            </template>
          </el-table-column>
          <el-table-column prop="staffNames" label="检修人">
            <template slot-scope="scope">
              <span v-for="(item, index) in scope.row.staffNames" :key="index">
                {{ scope.row.staffNames.length-1 > index ? item+'、' : item }}
              </span>
            </template>
          </el-table-column>
          <el-table-column label="状态" width="160">
            <template slot-scope="scope">
              <el-tag type="warning" v-if="scope.row.examineStatus==0 && scope.row.status!=1">未检修</el-tag>
              <div v-if="scope.row.examineStatus==0 && scope.row.status==1">
                <el-tag type="warning" style="margin-right:10px;">未检修</el-tag>
                <el-tag>继续检修</el-tag>
              </div>
              <div v-if="scope.row.examineStatus==1 && scope.row.status==3">
                <el-tag type="success" style="margin-right:10px;">已检修</el-tag>
                <el-tag type="danger" style="margin-right:10px;">审核中</el-tag>
              </div>
              <el-tag type="danger" v-if="scope.row.status==2">未解决</el-tag>
              <el-tag type="success" v-if="scope.row.status==4">已解决</el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="updateTime" label="检修提交时间" width="160">
            <template slot-scope="scope">
              {{ scope.row.updateTime ? dayjs(scope.row.updateTime).format('YYYY-MM-DD HH:mm:ss') : '-' }}
            </template>
          </el-table-column>
          <el-table-column label="操作" width="150">
            <template slot-scope="scope">
              <el-dropdown v-if="staffId == scope.row.creatorId" placement="bottom-start" trigger="click">
                <span @click.stop="">
                  <span class="el-dropdown-link">
                    操作<i class="el-icon-arrow-down"></i>
                  </span>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item><div @click="details(scope.row)">详情</div></el-dropdown-item>
                  <el-dropdown-item :disabled="roleId == 4 || scope.row.status != 1"><div @click="edit(scope.row)">编辑</div></el-dropdown-item>
                  <el-dropdown-item :disabled="roleId == 4"><div @click="dlt(scope.row)">删除</div></el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
              <el-dropdown v-else placement="bottom-start" trigger="click">
                <span @click.stop="">
                  <span class="el-dropdown-dis">
                    操作<i class="el-icon-arrow-down"></i>
                  </span>
                </span>
                <el-dropdown-menu slot="dropdown"></el-dropdown-menu>
              </el-dropdown>
            </template>
          </el-table-column>
        </el-table>
        <page v-if="total!==0" :size="size" :page="page" :total="total" v-on:sizeChange="sizeChange" v-on:pageChange="pageChange"></page>
      </div>
    </div>
  </div>
</template>

<script>
import page from '@/components/page.vue'
import dayjs from 'dayjs';
export default {
  components: {
    page
  },
  data() {
    return {
      loading: false,
      size: 50,
      page: 1,
      total: 0,
      tableData: [],
      staffId: 0,
      roleId: 0
    }
  },
  methods: {
    dayjs,
    details(row) {
      this.$router.push({ name: 'overhaulDynamicDetail', params: {row: row}})
    },
    edit(row) {
      if(row.status == 0) {
        this.$message.error('客户端未提交任务，不可编辑')
      }else if(row.status == 1){
        this.$router.push({ name: 'overhaulDynamicEdit', params: {row: row}})
      }else {
        this.$message.error('检修计划已提交，不可编辑')
      }
    },
    dlt(row) {
      this.$confirm("确认删除?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$ajax.post("reconditionTaskDel", {
          reconditionId: row.reconditionId,
        }).then((res) => {
          this.loadTableData();
        });
      });
    },
    pageChange(val) {
      this.page = val
      sessionStorage.setItem('currentPage', val)
      this.loadTableData()
    },
    sizeChange(val) {
      this.size = val
      sessionStorage.setItem('currentSize', val)
      this.loadTableData()
    },
    getLastPage() {
      this.page = Number(sessionStorage.getItem('currentPage')) || 1
    },
    getSize() {
      this.size = Number(sessionStorage.getItem('currentSize')) || 50
    },
    loadTableData() {
      this.loading = true
      this.$ajax.post('reconditionDynamic', {
        pageNum: this.page,
        pageSize: this.size,
      }).then(res => {
        this.tableData = res.data
        this.total = res.total
        this.loading = false
      }).catch(err=>{
        this.loading = false
      })
    }
  },
  mounted() {
    this.getLastPage()
    this.getSize()
    this.loadTableData()
    this.staffId = sessionStorage.getItem('id')
    this.roleId = sessionStorage.getItem('r')
  },
  destroyed() {
    // sessionStorage.removeItem('currentPage')
    // sessionStorage.removeItem('currentSize')
  }
}
</script>

<style lang="less" scoped>
.mains {
  padding: 400px 0;
  height: 100%;
}
/deep/.el-loading-spinner .el-icon-loading{
  font-size: 50px;
}
.el-dropdown-dis {
  color: #ccc;
  cursor: not-allowed;
}
.btn {
  float: right;
}
</style>